import { type FC, useMemo, useState } from 'react';

import styles from '../styles/booking-cancel-dialog.module.scss';

import { ActionDialog } from '../components/action-dialog';

const BookingCancelDialog: FC<{
    confirmationId: string;
    startAt: string;
    shopName: string;
    name?: string;
    phoneNumber?: string;
    onClose: () => void;
    onExecute: () => Promise<void>;
}> = ({ confirmationId, startAt, shopName, name, phoneNumber, onClose, onExecute }) => {
    const [processing, setProcessing] = useState(false);
    const bookingDate = useMemo(() => {
        return startAt.split(' ')[0] ?? '';
    }, [startAt]);

    const onOk = async () => {
        if (processing) {
            return;
        }
        setProcessing(true);
        try {
            await onExecute();
        } catch (e) {
            alert((e as Error).message);
        } finally {
            setProcessing(false);
        }
    };

    return (
        <ActionDialog
            title="以下の予約をキャンセルします"
            onClose={onClose}
            onOk={onOk}
            loading={processing}
        >
            <div className={styles.bookingInfoBox}>
                {name && <div>{`氏名：${name}`}</div>}
                {phoneNumber && <div>{`携帯電話番号：${phoneNumber}`}</div>}
                <div>{`予約番号：${confirmationId}`}</div>
                <div>{`予約店舗：${shopName}`}</div>
                <div>{`予約日：${bookingDate}`}</div>
            </div>
        </ActionDialog>
    );
};

export default BookingCancelDialog;
